export function materialList() {
    const material = [
        { value: 'Absorptiekorrels', text: 'Absorptiekorrels' },
        { value: 'Aluminium', text: 'Aluminium' },
        { value: 'Asfalt', text: 'Asfalt' },
        { value: 'Asfalt(open)', text: 'Asfalt(open)' },
        { value: 'Asfaltbeton', text: 'Asfaltbeton' },
        { value: 'Asfaltbeton(open)', text: 'Asfaltbeton(open)' },
        { value: 'Beplanting', text: 'Beplanting' },
        { value: 'Beton', text: 'Beton' },
        { value: 'Betonpuin', text: 'Betonpuin' },
        { value: 'Bitumen', text: 'Bitumen' },
        { value: 'Bomen', text: 'Bomen' },
        { value: 'Boomschors', text: 'Boomschors' },
        { value: 'Cementbeton', text: 'Cementbeton' },
        { value: 'Elektrotechniek', text: 'Elektrotechniek' },
        { value: 'Elementen', text: 'Elementen' },
        { value: 'Emaille', text: 'Emaille' },
        { value: 'Epoxy', text: 'Epoxy' },
        { value: 'Fauna', text: 'Fauna' },
        { value: 'EPS', text: 'Geëxpandeerd polystyreen(EPS)' },
        { value: 'Gietijzer', text: 'Gietijzer' },
        { value: 'Gips', text: 'Gips' },
        { value: 'Glas', text: 'Glas' },
        { value: 'Glaswol', text: 'Glaswol' },
        { value: 'Granulaat', text: 'Granulaat' },
        { value: 'Gras', text: 'Gras' },
        { value: 'Gravel', text: 'Gravel' },
        { value: 'Grind', text: 'Grind' },
        { value: 'Grond', text: 'Grond' },
        { value: 'Halfverhard', text: 'Halfverhard' },
        { value: 'Hout', text: 'Hout' },
        { value: 'Hydrauliek', text: 'Hydrauliek' },
        { value: 'Installaties', text: 'Installaties' },
        { value: 'Jute', text: 'Jute' },
        { value: 'Keramiek', text: 'Keramiek' },
        { value: 'Kit', text: 'Kit' },
        { value: 'Koper', text: 'Koper' },
        { value: 'Kunstgras', text: 'Kunstgras' },
        { value: 'Kunststof', text: 'Kunststof' },
        { value: 'Kurk', text: 'Kurk' },
        { value: 'Linoleum', text: 'Linoleum' },
        { value: 'Mechaniek', text: 'Mechaniek' },
        { value: 'Metaal', text: 'Metaal' },
        { value: 'Metselwerk', text: 'Metselwerk' },
        { value: 'Onverhard', text: 'Onverhard' },
        { value: 'Pneumatiek', text: 'Pneumatiek' },
        { value: 'Riet', text: 'Riet' },
        { value: 'Rubber', text: 'Rubber' },
        { value: 'Schelpen', text: 'Schelpen' },
        { value: 'Slakken', text: 'Slakken' },
        { value: 'Staal', text: 'Staal' },
        { value: 'Steen', text: 'Steen' },
        { value: 'Steenpuin', text: 'Steenpuin' },
        { value: 'Steenwol', text: 'Steenwol' },
        { value: 'Stortsteen', text: 'Stortsteen' },
        { value: 'Tapijt', text: 'Tapijt' },
        { value: 'Textie', text: 'Textiel' },
        { value: 'Thermoplas', text: 'Thermoplast' },
        { value: 'Vilt', text: 'Vilt' },
        { value: 'Water', text: 'Water' },
        { value: 'Wegenverf', text: 'Wegenverf' },
        { value: 'Zand', text: 'Zand' },
        { value: 'Zetsteen', text: 'Zetsteen' },
        { value: 'Zink', text: 'Zink' },
        { value: 'Anders', text: 'Anders' },
        { value: 'Onbekend', text: 'Onbekend' },
    ];

    return material;
}
